import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {DefaultService} from './abstract/default.service';
import {BehaviorSubject} from "rxjs";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";

@Injectable()
export class SharedNavigationService extends DefaultService {

    onItemUpdate: BehaviorSubject<any>;
    private previousUrl: string | undefined;
    private currentUrl: string | undefined;

    constructor(public override http: HttpClient,private router: Router) {
        super(http);
        this.setResourceLink('navigation/menu');
        this.onItemUpdate = new BehaviorSubject([]);
        this.currentUrl = this.router.url;
        router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            console.log('previousUrl', this.previousUrl);
            this.previousUrl = this.currentUrl;
            this.currentUrl = event.url;
        });
    }

    public getPreviousUrl(): string | undefined {
        return this.previousUrl;
    }

}
